import { FormControl, Grid, InputBase, MenuItem, Select, withTheme } from '@material-ui/core';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const BootstrapInput = withStyles(theme => ({
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ddd',
        fontSize: 14,
        fontWeight: 500,
        color: '#aaa',
        padding: '10px 20px',
        width: '212px',
        '&:focus': {
            borderRadius: 0,
            backgroundColor: '#fff'
        }
    }
}))(InputBase);

const StyledMenuItem = withStyles({
    root: {
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)'
        }
    },
    selected: {
        backgroundColor: '#254056',
        '&:hover': {
            backgroundColor: 'rgba(37, 64, 86, 0.14)'
        }
    }
})(MenuItem);

const FilterDropdown = ({
    options,
    label,
    value,
    setValue,
    justify = 'center',
    SelectProps = {},
    children = null
}) => {
    const validChildren = React.Children.toArray(children).filter(child =>
        React.isValidElement(child)
    );

    return (
        <Grid item container className="golf-options" justifyContent={justify}>
            <Grid item className="mb-2">
                {label && <p id="activities-sort-label">{label}</p>}
                <FormControl>
                    <Select
                        width="100%"
                        input={<BootstrapInput />}
                        labelId="activities-sort-label"
                        id="activities-sort-select"
                        value={value}
                        onChange={event => {
                            setValue(event.target.value);
                        }}
                        {...SelectProps}
                    >
                        {validChildren.length > 0
                            ? validChildren
                            : options.map(e => (
                                  <StyledMenuItem key={e.value} value={e.value}>
                                      {e.name}
                                  </StyledMenuItem>
                              ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default withTheme(FilterDropdown);
